import { render, staticRenderFns } from "./promotionAgreement.vue?vue&type=template&id=7f680918&scoped=true"
var script = {}
import style0 from "./promotionAgreement.vue?vue&type=style&index=0&id=7f680918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f680918",
  null
  
)

export default component.exports